import contentfulGql from 'js/lib/contentfulGql';

export const EntityFAQQuery = contentfulGql`#graphql
  query BrowseEntityFAQQuery($preview: Boolean!, $contentfulPageId: String!, $pageTypeSlug: String!, $locale: String!) {
    browseEntityPageCollection(
      preview: $preview
      locale: $locale
      where: { slug: $contentfulPageId, pageTypeSlug: $pageTypeSlug }
    ) {
      items {
        slug
        faqsCollection {
          items {
            sectionName
            question
            answer
          }
        }
      }
    }
  }
`;
